var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDecoration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 253,
    height: 33,
    viewBox: "0 0 253 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 253,
    height: 33,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.967,106.2l8.965-8.732-8.965-8.732-8.955,8.732,8.965,8.732",
    transform: "translate(-34.472 -78.774)",
    fill: "none",
    stroke: "#1a1818",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.788
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.967,97.469l8.965-8.732-8.965-8.732-8.955,8.732Z",
    transform: "translate(-34.472 -78.757)",
    fill: "none",
    stroke: "#1a1818",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.788
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.316,
    transform: "translate(0.906 17.154)",
    fill: "none",
    stroke: "#1a1818",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.811
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.708,95.919l-5.638,5.491L172.016,90.645l2.155-2.1,4.679,4.558-4.679,4.558-13.21-12.866-13.19,12.866L143.093,93.1l4.679-4.558,2.155,2.1-11.053,10.766-5.638-5.491",
    transform: "translate(-34.472 -78.757)",
    fill: "none",
    stroke: "#1a1818",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.788
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.316,
    transform: "translate(153.778 17.154)",
    fill: "none",
    stroke: "#1a1818",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.811
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.344,
    height: 7.153,
    strokeWidth: 1.788,
    fill: "none",
    stroke: "#1a1818",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    transform: "translate(121.307 26.678) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.834,100.733h-4.3l-5.428-5.287-9.673,9.422-12.464-12.14-12.464,12.14-9.673-9.422-5.428,5.287h-4.3",
    transform: "translate(-34.472 -78.768)",
    fill: "none",
    stroke: "#1a1818",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.788
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoration);
export default __webpack_public_path__ + "static/media/Decoration.aad75271e33dd889f25b0e24a5e6c0b2.svg";
export { ForwardRef as ReactComponent };